import { fetchListData } from "components/list/useListQuery";

function stateManagerKey(endpoint, version) {
  return `react-list--${endpoint}--${version}`;
}

export default {
  stateManager: {
    init(context) {
      const { endpoint, version } = context;
      const latestKey = stateManagerKey(endpoint, version);
      const storageKeyBase = String(version || "").replace(/\d+$/, "");
      const targetPrefix = storageKeyBase
        ? `react-list--${endpoint}--${storageKeyBase}`
        : `react-list--${endpoint}--`;

      const staleKeys = Object.keys(localStorage).filter(
        (key) => key.startsWith(targetPrefix) && key !== latestKey
      );
      staleKeys.forEach((key) => {
        try {
          localStorage.removeItem(key);
        } catch (e) {
          // Ignore localStorage errors
        }
      });
    },

    set(context) {
      const {
        endpoint,
        version,
        search,
        page,
        perPage,
        sortBy,
        sortOrder,
        filters,
        attrSettings,
      } = context;
      const key = stateManagerKey(endpoint, version);
      localStorage.setItem(
        key,
        JSON.stringify({
          search,
          page,
          perPage,
          sortBy,
          sortOrder,
          filters,
          attrSettings,
        })
      );
    },

    get(context) {
      const { endpoint, version } = context;
      const key = stateManagerKey(endpoint, version);
      try {
        if (localStorage.getItem(key)) {
          return JSON.parse(localStorage.getItem(key));
        } else {
          return null;
        }
      } catch {
        return null;
      }
    },
  },

  requestHandler: fetchListData,
};
